import React, { useState } from 'react'
import PropTypes from 'prop-types'

import CheckboxItem from './CheckboxItem'
import ChecAccordionItem from './CheckAccordionItem'
import { ToggleButton } from '../Accordion/style'
import { CheckBoxGroup, CheckBoxHeader, CheckBoxTitle } from './style'
const CheckBox = ({
  title,
  isAccordionData,
  data,
  toggleSelection,
  focusedInfoModalBtnIndex,
}) => {
  const [isAllChecked, setAllChecked] = useState(false)
  function handleClicked() {
    setAllChecked(!isAllChecked)
    if (isAllChecked) {
      toggleSelection(0)
    } else {
      toggleSelection(data.length)
    }
  }
  return (
    <CheckBoxGroup>
      <CheckBoxHeader>
        <CheckBoxTitle>{title}</CheckBoxTitle>
        {isAccordionData ? null : (
          <ToggleButton
            onClick={() => handleClicked()}
            autoFocus={true}
            aria-label={
              isAllChecked
                ? `Deselect all button, to deselect all ${title} double click here`
                : `Select allbutton, to select all ${title} double click here`
            }
          >
            {isAllChecked ? 'Deselect all' : 'Select all'}
          </ToggleButton>
        )}
      </CheckBoxHeader>
      {isAccordionData
        ? data.map((item, index) => (
            <ChecAccordionItem
              item={item}
              index={index}
              key={index}
              isChecked={isAllChecked}
            />
          ))
        : data.map((item, index) => (
            <CheckboxItem
              item={item}
              index={index}
              key={index}
              isChecked={isAllChecked}
              isInfoBtnFocused={
                index === focusedInfoModalBtnIndex ? true : false
              }
            />
          ))}
    </CheckBoxGroup>
  )
}

CheckBox.propTypes = {
  title: PropTypes.string,
  isAccordionData: PropTypes.bool,
  data: PropTypes.array,
}

export default CheckBox
